/**
 * Maps raw backend RequestStatus enum values to human-readable labels.
 * "Company" in the backend means OmniDrive — the platform doing the review.
 */
export const STATUS_LABELS = {
  NEW:                    'New',
  ASSIGNED:               'Assigned',
  VENDOR_SUBMITTED:       'Pending Review',
  COMPANY_APPROVED:       'OmniDrive Approved',
  COMPANY_REJECTED:       'OmniDrive Rejected',
  PENDING_FINAL_APPROVAL: 'Awaiting CVA Approval',
  CLIENT_APPROVED:        'Fully Approved',
  CLIENT_REJECTED:        'Account Rejected',
  CVA_REJECTED:           'CVA Rejected',
  CANCELLED:              'Cancelled',
};

/** Returns a readable label for a status value, falling back to the raw value. */
export function statusLabel(status) {
  return STATUS_LABELS[status] || (status ? status.replace(/_/g, ' ') : '—');
}

/** Ready-to-use STATUSES array for filter <select> dropdowns. */
export const STATUS_OPTIONS = [
  { value: '',                       label: 'All Statuses' },
  { value: 'NEW',                    label: 'New' },
  { value: 'ASSIGNED',               label: 'Assigned' },
  { value: 'VENDOR_SUBMITTED',       label: 'Pending Review' },
  { value: 'COMPANY_APPROVED',       label: 'OmniDrive Approved' },
  { value: 'COMPANY_REJECTED',       label: 'OmniDrive Rejected' },
  { value: 'PENDING_FINAL_APPROVAL', label: 'Awaiting CVA Approval' },
  { value: 'CLIENT_APPROVED',        label: 'Fully Approved' },
  { value: 'CLIENT_REJECTED',        label: 'Account Rejected' },
  { value: 'CVA_REJECTED',           label: 'CVA Rejected' },
  { value: 'REJECTED',               label: 'All Rejected (OmniDrive + Account)' },
  { value: 'CANCELLED',              label: 'Cancelled' },
];

/** STATUS_OPTIONS filtered to vendor-relevant statuses only. */
export const VENDOR_STATUS_OPTIONS = STATUS_OPTIONS.filter(s =>
  ['', 'ASSIGNED', 'VENDOR_SUBMITTED', 'COMPANY_APPROVED', 'COMPANY_REJECTED', 'CLIENT_REJECTED', 'CVA_REJECTED', 'REJECTED', 'CLIENT_APPROVED', 'PENDING_FINAL_APPROVAL', 'CANCELLED'].includes(s.value)
);

/** STATUS_OPTIONS filtered to client-relevant statuses only.
 *  COMPANY_APPROVED is relabelled "Pending Review" for the client view —
 *  from the client's perspective this means OmniDrive has approved the vendor
 *  submission and the item is now awaiting their own review/action.
 */
export const CLIENT_STATUS_OPTIONS = STATUS_OPTIONS
  .filter(s =>
    ['', 'NEW', 'ASSIGNED', 'VENDOR_SUBMITTED', 'COMPANY_APPROVED', 'CLIENT_APPROVED', 'CLIENT_REJECTED', 'CVA_REJECTED', 'REJECTED', 'PENDING_FINAL_APPROVAL', 'CANCELLED'].includes(s.value)
  )
  .map(s => {
    if (s.value === 'VENDOR_SUBMITTED')  return { ...s, label: 'Vendor Submitted' };
    if (s.value === 'COMPANY_APPROVED')  return { ...s, label: 'Pending Review' };
    return s;
  });
